<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana rana-shell-flush">
        <div class="section-1400 rana-full-bleed">
            <div class="container-fluid px-0">
                <div class="row justify-content-center">
                    <div class="row no-gutters sticky-wrapper rana-shell" id="accordionExample">
                        <div class="col-lg-4 rana-shell-rail">
                            <div class="section border-4 p-3 p-xl-4 z-bigger rana-nav-rail"
                                 id="sticker-careers">
                                <div class="row">
                                    <div class="col-12 d-lg-none">
                                        <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                                data-target="#businessNavRailLinks" aria-expanded="false"
                                                aria-controls="businessNavRailLinks">
                                            <span>Menu</span>
                                            <i class="uil uil-angle-down size-20"></i>
                                        </button>
                                    </div>
                                    <div class="col-12 collapse d-lg-block" id="businessNavRailLinks">
                                        <a href="#page-scroll" data-gal='m_PageScroll2id'
                                           class="btn btn-user-profile btn-fluid justify-content-start px-3"
                                           data-toggle="collapse"
                                           data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Scholarship Awards
                                        </a>
                                        <a href="#page-scroll" data-gal='m_PageScroll2id'
                                           class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3 mb-4"
                                           data-toggle="collapse"
                                           data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Education Fund
                                        </a>
                                        <div class="ed mt-4"></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">
                            <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">

                                <div id="collapseOne" class="collapse p-0 show" data-parent="#accordionExample">
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-12">
                                                <h5 class="mb-3">
                                                    Scholarship Awards - 2024

                                                </h5>
                                            </div>
                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>
                                            <div class="col-12">
                                                <p class="mb-3 font-weight-500">
                                                    Dear RANA Members,

                                                </p>
                                                <p class="mb-1">
                                                    As you know RANA education trust fund (ETF) is our charity fund.
                                                    Every year we give out
                                                    scholarships to needy & deserving Rajput students in India. </p>
                                                <p class="mb-4">
                                                    This year 2023 to 2024 , RANA National Executive committee (NEC) has
                                                    decided & awarded
                                                    scholarships to 33 college students in India. Awards are based on
                                                    multiple criteria, such as,
                                                    amount of tuition, sponsor recommendation, family finance
                                                    situations, research, analysis and
                                                    verification of various supporting data submitted by applicants. In
                                                    this manner RANA is
                                                    helping deserving students achieve their education goals and obtain
                                                    their degrees.

                                                </p>
                                                <p class="mb-2">
                                                    This is only possible with your help by donating to the RANA
                                                    education trust fund (ETF). I
                                                    like to appeal our RANA family members, their family and friends to
                                                    contribute IRS deductable
                                                    donation for 2023. RANA ETF is Charted under IRC section 501(C)(3),
                                                    and as such donations to
                                                    Charity are tax deductible for individuals & businesses.

                                                </p>
                                                <p class="mb-2">
                                                    Please send your donations by check to listed below address:

                                                </p>
                                                <p class="mb-2 font-weight-600">
                                                    RANA education trust fund
                                                </p>
                                                <p class="mb-0">Attn: Dilipsinh Rathod</p>
                                                <p class="mb-0"> 16 Joseph dr</p>
                                                <p class="mb-1">Sewell , NJ 08080 </p>


                                                <p class="mb-1">
                                                    Or you can pay using PayPal using link below or on our website at
                                                    rajputra.org website:
                                                </p>
                                                <p class="mb-2 font-weight-500">
                                                    <a
                                                            href="https://www.paypal.com/donate/?hosted_button_id=6N6UNJ6HD5LNA">https://www.paypal.com/donate/?hosted_button_id=6N6UNJ6HD5LNA</a>

                                                </p>
                                                <p class="mb-2">
                                                    We will provide you donation receipt to claim on your tax return.
                                                    Please support this noble
                                                    cause to our beloved community students. Please feel free to call me
                                                    at <span
                                                        class="font-weight-600">856-889-4531</span> or email <span
                                                        class="font-weight-600">education&#64;rajputra.org</span>

                                                </p>
                                                <p class="mb-5">
                                                    With best regards to you and your family

                                                </p>

                                                <p class="mb-0">Sincerely,</p>
                                                <p class="mb-0 font-weight-500">NEC Education secretary & Committee</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="collapseTwo" class="collapse p-0" data-parent="#accordionExample">
                                    <div class="card-body p-0">
                                        <div class="row">
                                            <div class="col-12">
                                                <h5 class="mb-3">
                                                    RANA Education Trust Fund
                                                </h5>
                                            </div>
                                            <div class="col-12 pb-3">
                                                <div class="section divider divider-gray"></div>
                                            </div>
                                            <div class="col-12">

                                                <p class="mb-1">
                                                    RANA Education Trust Fund is charted under IRC Section 501(c)(3),
                                                    and as such the donations to
                                                    the RANA Education Trust Fund are tax-deductible. Please send your
                                                    donations to Education
                                                    Chairman payable by PayPal OR mail check to: </p>
                                                <p class="mb-2 font-weight-500">
                                                    RANA EDUCATION TRUST FUND
                                                </p>
                                                <p class="mb-0">
                                                    16 Joseph Dr
                                                </p>
                                                <p class="mb-0">
                                                    Sewell, NJ, 08080
                                                </p>


                                                <div class="row px-0 justify-content-center">

                                                    <div
                                                            class="col-8 px-0 align-self-center mb-5 mb-xl-0 pb-4 pb-xl-0"
                                                            data-scroll-reveal="enter right move 40px over 0.5s after 0.3s">
                                                        <div class="row justify-content-center mb-4">

                                                            <div class="section border-4 services-wrap-3 px-3 px-xl-4 py-4 py-xl-5 text-center">
                                                                <h5 class="mb-3">
                                                                    RANA Scholarships in India
                                                                </h5>
                                                                <p class="mb-0">
                                                                    Presently, RANA distributes individual scholarships
                                                                    of up to Rs. 15,000 each annually
                                                                    to needy and qualified Rajput students in India.
                                                                    Deadline is August 15. </p>
                                                                <a class="btn btn-fluid btn-success"
                                                                   href="https://www.rajputra.org/images/RANA_Scholarship_Application_Form_2024-25_INDIA.pdf">
                                                                    Download Education Form</a>
                                                            </div>
                                                        </div>


                                                        <div class="row justify-content-center mb-4">
                                                            <div class="section border-4 services-wrap-3 px-3 px-xl-4 py-4 py-xl-5 text-center">

                                                                <div class="col">
                                                                    <h5 class="mb-3">
                                                                        RANA Scholarships for Members' Children in US
                                                                        and Canada </h5>
                                                                    <p class="mb-0">
                                                                        Presently, RANA distributes individual
                                                                        scholarships of $1000 each annually to
                                                                        needy and qualified children of RANA members in
                                                                        North America. Deadline is Nov
                                                                        30th.
                                                                    </p>
                                                                    <a class="btn btn-fluid btn-success"
                                                                       href="https://www.rajputra.org/images/Rana-Scholarship-Application-Form-2023-24-USA_CANADA.pdf">
                                                                        Download Education Form</a>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div class="row ">

                                                            <div class="section border-4 services-wrap-3 px-3 px-xl-4 py-4 py-xl-5 text-center">
                                                                <h5 class="mb-3">
                                                                    Scholarships Awarded in India during 2021-2023
                                                                </h5>
                                                                <p class="mb-0">
                                                                    We would like to announce that the RANA committee
                                                                    has allocated 25 academic
                                                                    scholarships for Indian students for the year of
                                                                    2022-2023. Please find students
                                                                    list with other details in document.
                                                                </p>
                                                                <a class="btn btn-fluid btn-success"
                                                                   href="https://www.rajputra.org/images/RANA-Scholarship-List-2022-2023-2022-10_12.pdf">
                                                                    Download Education Form</a>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>